import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  SetSalaryStructureStatusGraphQLResponse,
  SetSalaryStructureStatusGraphQLRequest,
} from '../types';

const setSalaryStructureStatusMutation = gql`
  mutation PayrollSetSalaryStructureStatus($input: PayrollSetSalaryStructureStatusInput!) {
    payrollSetSalaryStructureStatus(input: $input) {
      data {
        results {
          updateStatus
          salaryStructureId
          oldStatus
          newStatus
          errorMessage
        }
      }
      code
      success
      message
    }
  }
`;

const setSalaryStructureStatus = (queryVariables: SetSalaryStructureStatusGraphQLRequest) => {
  return graphQLApi<
    SetSalaryStructureStatusGraphQLResponse,
    SetSalaryStructureStatusGraphQLRequest
  >({
    query: setSalaryStructureStatusMutation,
    queryVariables,
  });
};

export default setSalaryStructureStatus;
